import React, { Component } from "react";
import "./Dani.css";
import DaniIcon from "./../../assets/dani_icon.svg";
import DaniClose from "./../../assets/dani_close.svg";
// import DaniSmallClose from './../../assets/dani_small_close.svg';
import DaniSmallClose from "./../../assets/cancel.png";
import { BiChevronDown } from "react-icons/bi";
import { CgArrowsExpandLeft } from "react-icons/cg";

class DaniFloatButton extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hideIconTemp: false,
    };
  }
  showHelpText = () => {
    const { currentRoute } = this.props;
    const { currentStep, minimized, opened } = this.props;
    if (minimized && opened) {
      if (currentStep.options) {
        return `Unless you have a question, you can close this chat. I look forward to 
          chatting again soon! ⭐`;
      } else if (currentStep.showInput) {
        return `Ok. Please type your DEI-related question in a few words.`;
      } else {
        return `Unless you have anything else, you can close this chat. I look forward to 
        chatting again soon! ⭐`;
      }
    }
    if (
      currentRoute.contains("analytics") &&
      !currentRoute.contains("edit") &&
      !currentRoute.contains("create")
    ) {
      return `Want to ask a question or take an action?`;
    }
    return `Have a question?`;
  };

  render() {
    console.log('Float Button DANI ------')
    const { opened, showHelpText, minimized } = this.props;
    const {hideIconTemp} = this.state
    return (
      <a
        className={
          opened && !minimized
            ? "dani-close-float-button"
            : "dani-icon-float-button"
        }
      >
        {opened && !minimized ? (
          <span>
            <BiChevronDown
              size={"40px"}
              color="white"
              onClick={this.props.onFloatButtonClick}
            />
          </span>
        ) : (
          <div>
            {minimized && opened ? (
              <div
                style={{ display: "flex" }}
                onClick={this.props.onFloatButtonClick}
              >
                <div className="dani-view-more">View More</div>
                <div>
                  <img
                    src={DaniSmallClose}
                    height="11px"
                    width="11px"
                    style={{ margin: "5px 10px" }}
                    onClick={this.props.onCloseDani}
                  />
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: !hideIconTemp ? "flex" : "none",
                  justifyContent: "flex-end",
                }}
              >
                <img
                  src={DaniSmallClose}
                  height="11px"
                  width="11px"
                  style={{ margin: "5px 10px" }}
                  onClick={() => {
                    // this.props.onCloseHelpText();
                    this.setState({ hideIconTemp: true });
                  }}
                />
              </div>
            )}
            <div
              onClick={this.props.onFloatButtonClick}
              className="dani-hint"
              style={{ display: !hideIconTemp && showHelpText ? "block" : "none" }}
            >
              {this.showHelpText()}
            </div>
            {
              hideIconTemp ? <CgArrowsExpandLeft className="cursor-pointer" onClick={()=>{ this.setState({hideIconTemp:false}) }} />  :  <img
              className="dani-icon"
              style={{
                width: "105px",
                float: "right",
                display: !hideIconTemp ? "block" : "none",
              }}
              src={DaniIcon}
              onClick={this.props.onFloatButtonClick}
            />
            }
           
          </div>
        )}
      </a>
    );
  }
}

export default DaniFloatButton;
